import { Controller } from "@hotwired/stimulus"

// Receives push tokens from native shells (CustomEvent) and registers them with Rails
// using the WebView session cookie. See ios/RateMyBottle/SceneController.swift and
// android/.../MainActivity.kt.
export default class extends Controller {
  static values = {
    platform: String
  }

  connect () {
    this.boundHandler = this.handleNativeToken.bind(this)
    window.addEventListener("ratemybottle:apns-device-token", this.boundHandler)
    window.addEventListener("ratemybottle:fcm-device-token", this.boundHandler)
  }

  disconnect () {
    window.removeEventListener("ratemybottle:apns-device-token", this.boundHandler)
    window.removeEventListener("ratemybottle:fcm-device-token", this.boundHandler)
  }

  async handleNativeToken (event) {
    const token = event.detail?.token
    if (!token || !this.platformValue) return
    if (this.lastPosted === token) return

    try {
      const res = await fetch("/api/device_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ platform: this.platformValue, token })
      })
      if (res.ok) this.lastPosted = token
    } catch (e) {
      console.error(e)
    }
  }
}
